import React, { Component } from 'react';

import ModelViewerCard from './ModelViewerCard';
import models from "../assets/models/models.json";

class Main extends Component {


    render() {
        return (
            <main>
                {
                    models.map((model, i) => {
                        
                        return (
                            <ModelViewerCard
                                key={i}
                                model={model}
                            />
                        );
                    })
                }
            </main>
        );
    }
}

export default Main;
